import { endpoints } from "../apiEndpoints/apiEndpoints";
import apiService from "../services/apiCore";

// ✅ Add Batch
export const addBatchesAPI = async (data) => {
  try {
    const response = await apiService.post(endpoints.addBatches, data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ✅ Update Batch
export const updateBatchesAPI = async ({ id, data }) => {
  try {
    const response = await apiService.put(`${endpoints.updateBatches}/${id}`, data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ✅ Get Batches List
export const getBatchesListAPI = async ({ page = 1, limit = 10, search = "", company_id, excludeManagement, excludeOpenBatch } = {}) => {
  try {
    const params = { page, limit, search };
    if (company_id) params.company_id = company_id;
    if (excludeManagement !== undefined) params.excludeManagement = excludeManagement;
    if (excludeOpenBatch !== undefined) params.excludeOpenBatch = excludeOpenBatch;
    const response = await apiService.get(endpoints.getBatchesList, params);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ✅ Get Batch Detail — now supports page & limit & company_id
export const getBatchesDetailAPI = async (id, { page = 1, limit = 10, company_id } = {}) => {
  try {
    const params = { page, limit };
    if (company_id) params.company_id = company_id;
    const response = await apiService.get(`${endpoints.getBatchesDetail}/${id}`, params);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ✅ Delete Batch
export const deleteBatchesAPI = async (id, company_id) => {
  try {
    const params = company_id ? { company_id } : {};
    const response = await apiService.delete(`${endpoints.deleteBatches}/${id}`, params);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ✅ Get Unassigned Employees for a Batch
export const getUnassignedEmployeesAPI = async (batchId, company_id) => {
  try {
    const params = company_id ? { company_id } : {};
    const response = await apiService.get(`${endpoints?.unassignedEmployees}/${batchId}`, params);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ✅ Add Employees to Batch
export const addEmployeesToBatchAPI = async ({ batchId, employeeIds, company_id }) => {
  try {
    const payload = {
      employee_ids: employeeIds,
    };
    if (company_id) payload.company_id = company_id;
    const response = await apiService.post(`${endpoints?.addemployee}/${batchId}`, payload);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ✅ Remove Employees from Batch
export const removeEmployeesFromBatchAPI = async ({ batchId, employeeIds, company_id }) => {
  try {
    const payload = {
      employee_ids: employeeIds,
    };
    if (company_id) payload.company_id = company_id;
    const response = await apiService.delete(`${endpoints?.removeEmployee}/${batchId}`, payload);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ✅ Get Batch Options (for dropdowns)
export const getBatchesOptionsAPI = async ({ company_id, excludeManagement } = {}) => {
  try {
    const params = {};
    if (company_id) params.company_id = company_id;
    if (excludeManagement !== undefined) params.excludeManagement = excludeManagement;
    const response = await apiService.get(endpoints?.batchesOptions, params);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ✅ Move Employees to Another Batch
export const moveBatchEmployeesAPI = async ({ targetBatchId, employeeIds, company_id }) => {
  try {
    const payload = {
      employee_ids: employeeIds,
    };
    if (company_id) payload.company_id = company_id;

    const response = await apiService.post(
      `${endpoints?.moveBatchEmployees}/${targetBatchId}`,
      payload
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};